import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getSiteSettings, updateSiteSettings } from "../api/siteApi";
import toast from "react-hot-toast";
import { useEffect } from "react";
// Fetch site settings
export const useSiteSettings = () => {
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useQuery({
    queryKey: ["siteSettings"],
    queryFn: getSiteSettings,
  });

  const updateSiteMutation = useMutation({
    mutationFn: ({ showDevBanner, devBannerMessage }) =>
      updateSiteSettings(showDevBanner, devBannerMessage),
    onSuccess: () => {
      toast.success("site updated successfully");
      queryClient.invalidateQueries({ queryKey: ["siteSettings"] });
    },
    onError: (error) => {
      console.error("Error updating site settings:", error);
      toast.error("something went wrong.");
    },
  });

  useEffect(() => {
    if (error) {
      toast.error("something went wrong");
    }
  }, [error]);

  return {
    data,
    isLoading,
    updateSiteMutation,
  };
};
